export const TIME_FORMAT = 'DD-MM-YYYY HH:mm'
export const PRECISE_TIME_FORMAT = 'DD-MM-YYYY HH:mm:ss'
export const PRECISE_ONLY_TIME_FORMAT = 'HH:mm:ss'
export const ONLY_TIME_FORMAT = 'HH:mm'
export const DATE_FORMAT = 'YYYY-MM-DD'
export const MONTH_FORMAT = 'MM-YYYY'
export const SERVICE_TIME_FORMAT = 'YYYY-MM-DD HH:mm'
export const SERVICE_DATE_FORMAT = 'YYYY-MM-DD'
export const SERVICE_MONTH_FORMAT = 'YYYY-MM'
